import { Dialog } from "primereact/dialog";
import useDeleteRecordModal from "./useDeleteRecordModal";
import styles from "./style.module.scss";
import globalStyles from "../../style.module.scss"

const DeleteRecordModal = ({ isVisible, ...rest }) => {
    const { record, handleClose, header, footer, warningText } = useDeleteRecordModal(rest);

    return (
        record && (
            <Dialog className={globalStyles.actionModal}
                    header={header}
                    footer={footer}
                    visible={isVisible}
                    onHide={handleClose}
                    headerStyle={{ padding: "16px" }}
                    contentStyle={{ padding: "16px" }}
                    pt={{
                        footer: {
                            style: {
                                padding: "16px 4px 16px 16px",
                                backgroundColor: "#F9FAFB",
                            },
                        },
                    }}
            >
                <div className={`p-d-flex p-ai-center ${styles.notificationContainer}`}>
                    <i className="pi pi-exclamation-triangle"></i>
                    <div>
                        <strong>
                            Вы уверены, что хотите подтвердить запись?
                        </strong>
                        <p>"{record.nameRu}"</p>
                    </div>
                </div>
                <p className={styles.warningText}>{warningText}</p>
            </Dialog>
        )
    );
};

export default DeleteRecordModal;
